module.exports = __webpack_public_path__ + "static/media/exibex.f8a83ef1.gif";